import axios from "axios";
import React, { useState, useEffect } from "react";
import {
  Button,
  CardHeader,
  Col,
  Collapse,
  Form,
  Row,
  Label,
  InputGroup,
  Input,
} from "reactstrap";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import moment from "moment";
import { Redirect, Link } from "react-router-dom";
import { amButtonLabels } from "../../Forms/ShortFunction/shortFunctions";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { checkPermission, priorityLov } from "../../../Helper";
import { baseurl } from "../../../baseurl";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import ResponseLoader from "../../Forms/ShortCutComponents/ResponseLoader";
import ReactDatePicker from "../../Forms/ShortCutComponents/ReactDatePicker";
// import "./formsTable.css";
// import "./baseForms.css";
// import "./../inventoryTransferForm/inventoryTransferForm";
import { GrAttachment } from "react-icons/gr";
import AttachmentViewModal from "./../../Forms/ShortCutComponents/AttachmentViewModal";
let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");

export default function RefundCust(props) {
  const [table, setTable] = useState({
    OverViewDataTable: [],
  });
  const [priority, setPriority] = useState(null);
  const [costCenter, setCostCenter] = useState(null);
  const [priorityList, setPriorityList] = useState([]);
  const [costCenterList, setCostCenterList] = useState([]);
  const asyncRollCheck = async (value) => {
    let pathname = "/inventoryPDOverview";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  const [loadingResponse, setLoadingResponse] = useState(true);
  const [closePoModelIsOpen, setClosePoModelIsOpen] = useState(false);
  const [remarks, setremarks] = useState("");
  const [closeDate, setCloseDate] = useState(new Date());
  const [orderId, setOrderId] = useState(null);
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  useEffect(() => {
    const funCall = async (value) => {
      const openModalCheck = await asyncRollCheck(value);
    };
    funCall(0);
    getData();
    getPriorityLov();
    getCostCenterLov();
  }, []);

  const getData = () => {
    setLoadingResponse(true);
    axios
      .post(
        `${baseurl}/pointOfSale/getPurchaseDemand`,
        {
          companyId: companyId,
          username: username,
          demandType: 1,
          priority: priority ? priority.id : null,
          costCenter: costCenter ? costCenter.id : null,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("-----yelllooooowwww-------", res.data.data);
        let getRecipeCost = res.data.data;
        // loop laga kr "ORDER_STATUS" is column ma due and overdue calculate kro. on bacis of req_date and current date (use moment)
        // due means = req_date >= current date
        // overdue = req_date < current date
        // completed ka ma query ma flag deta

        const updatedArray = getRecipeCost.map((item) => {
          const reqDate = moment(item.req_date, "DD-MMM-YY"); // Parse the req_date
          const currentDate = moment(); // Current date

          const ORDER_STATUS = reqDate.isSameOrAfter(currentDate, "day")
            ? "due"
            : "overdue";

          return {
            ...item,
            ORDER_STATUS,
          };
        });

        // console.log("yelllooooowwww", updatedArray);
        setTable({
          // OverViewDataTable: getRecipeCost,
          OverViewDataTable: updatedArray,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        setLoadingResponse(false);
      });
  };
  function dueFormatorsComma2(cell, row, enumObject, index) {
    let cett = "";
    cett = parseFloat(cell);
    if (cell) {
      cett = cett?.toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
      // cett =cett;
    } else {
      cett = 0;
    }

    return cett;
  }
  const redirectToForm = (row, updateCheck) => {
    props.history.push({
      pathname: "/inventoryPDForm",
      state: {
        rowData: row,
        updateCheck: updateCheck ? 2 : 1,
      },
    });
  };
  const redirectToPDForm = (row, updateCheck) => {
    props.history.push({
      pathname: "/PurchaseOrderAgainstPD",
      state: {
        id: row?.pur_dem_id,
        demandType: 1,
        updateCheck: updateCheck ? 2 : 1,
        pdCheck: true,
      },
    });
  };
  const toggleClosePoModal = () => {
    setClosePoModelIsOpen(!closePoModelIsOpen);
    setremarks("");
  };

  const closePo = () => {
    // const { closeDate, remarks, orderId } = this.state;
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      size: "md",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Close PO!",
    }).then((result) => {
      if (result) {
        axios
          .post(
            `${baseurl}/masterData/closePurchaseDemand`,
            {
              id: orderId,
              date: closeDate,
              remarks: remarks,
              username: username,
              companyId: companyId,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            if (response.data.message === "success") {
              Swal.fire(
                "Closed!",
                "Your Purchase Order has been closed.",
                "success"
              );
              toggleClosePoModal();
              // thisContext.getOverviewData("All", "All");
            }
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: err,
              icon: "error",
              size: "md",
              button: "Try Again!",
            });
          });
      }
    });
  };
  const setDelete = async (row) => {
    const deleteCheck = await asyncRollCheck(3);
    if (deleteCheck) {
      return;
    }
    let rowId = row.pur_dem_id;
    let fr_sub_inv_id = row.fr_sub_inv_id;
    let date = row.dem_date;
    let docNo = row.doc_no;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoadingResponse(true);

        axios
          .post(
            `${baseurl}/pointOfSale/delPurchaseDemand`,
            {
              id: rowId,
              date,
              fr_sub_inv_id,
              username: username,
              companyId: companyId,
              productionNumber: docNo,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            setLoadingResponse(false);
            Swal.fire("Deleted!", "Your Record has been deleted.", "success");
            getData();
          })
          .catch((err) => {
            console.log(err);
            setLoadingResponse(false);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              button: "Try Again!",
            });
          });
      }
    });
  };

  const amAuth = (row) => {
    setLoadingResponse(true);
    axios
      .post(
        `${baseurl}/Authorizer/am_SendForAuth`,
        {
          companyId: companyId,
          // date: row.bill_date,
          date: moment().format("YYYY-MM-DD"),
          id: row.pur_dem_id,
          book_id: row.inv_book_id, //saif
          sub_inv_id: row.sub_inv_id, //saif
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )

      .then(function (res) {
        setLoadingResponse(false);
        const data = res.data.data;
        console.log("hellll", res, data);
        if (data) {
          swal({
            title: "Saved Successfully!",
            text: "Added",
            icon: "success",
          });
        } else {
          swal({
            title: "Send for App",
            text: "this doc is not submitted!.",
            icon: "warning",
          }).then(() => {
            window.location.reload();
          });
        }
      })
      .catch(function (error) {
        setLoadingResponse(false);
        console.log(error);
      });
  };
  function orderDetHandler(cell, row) {
    let element = row;
    console.log(element);
    let button = row.am_status;
    let buttonName, buttonTooltip, buttonDisable, iconName, iconTitle;
    if (button) {
      let buttonInfo = amButtonLabels(button);
      buttonName = buttonInfo.buttonName;
      buttonTooltip = buttonInfo.tooltip;
      buttonDisable = buttonInfo.disable;
      iconName = buttonInfo.iconName;
      iconTitle = buttonInfo.iconTitle;
    }
    let hasAttachment = false;
    if (element.attachment_file) {
      const rawVal = element.attachment_file.toString().trim();
      if (rawVal !== "" && rawVal !== "[]") {
        if (rawVal.startsWith("[") && rawVal.endsWith("]")) {
          try {
            const parsed = JSON.parse(rawVal);
            if (Array.isArray(parsed) && parsed.length > 0) {
              if (parsed.some((f) => f && f.trim() !== ""))
                hasAttachment = true;
            }
          } catch (e) {
            hasAttachment = true;
          }
        } else {
          hasAttachment = true;
        }
      }
    }
    return (
      <div>
        {button ? (
          <>
            <span>
              <img
                src={iconName}
                alt="Processing"
                title={iconTitle}
                style={{ width: "20px", height: "20px", marginRight: "8px" }}
              />
            </span>
            <span>
              <Button
                className="mr-1"
                size="sm"
                title={buttonTooltip}
                color="success"
                onClick={() => amAuth(row)}
                disabled={buttonDisable}
              >
                {buttonName}
              </Button>
            </span>
          </>
        ) : null}
        <span
          className={`mr-1 badge  ${
            element.ORDER_STATUS === "completed"
              ? "badge-success"
              : element.ORDER_STATUS === "overdue"
              ? "badge-danger"
              : "badge-warning"
          }`}
          // className="mr-1 badge badge-warning"
        >
          {" "}
          {element.ORDER_STATUS}
        </span>
        {!element.close_date ? (
          <Button
            type="submit"
            className="m-1"
            size="sm"
            color="primary"
            title={
              element?.flag_edit_del_btn === "completed"
                ? "completed"
                : "Purchase Against Order"
            }
            disabled={
              !element?.show_po || element?.flag_edit_del_btn === "completed"
            }
            onClick={() => redirectToPDForm(row, false)}
          >
            PO
          </Button>
        ) : null}
        <Button
          type="submit"
          className="m-1"
          size="sm"
          color="danger"
          title={`Remarks:${
            element.close_remarks ? element.close_remarks : ""
          }`}
          // disabled={!element.close_date ? false : true}
          disabled={element.show_close ? true : false}
          onClick={() => {
            setOrderId(row.pur_dem_id);
            toggleClosePoModal();
          }}
        >
          Close PD
        </Button>
        <span>
          <Link
            to={{
              pathname: "/transferPrints",
              state: {
                rowId: row.pur_dem_id,
                PrintName: "Purchase Demand",
                goBackUrl: "/purchaseDemandOverview",
              },
            }}
          >
            <Button
              style={{ margin: "3px" }}
              // onClick={() => redirectToForm(row, false)}
              class="btn btn-primary"
              size="sm"
            >
              <i className="fa fa-print" />
            </Button>
          </Link>
        </span>
        <span>
          <Button
            onClick={() => redirectToForm(row, false)}
            class="btn btn-secondary"
            size="sm"
          >
            <i className="fa fa-eye" />
          </Button>
          {/* <Link
            //    to={{
            //     pathname: "/inventoryTransferForm",
            //     state: { cell: "i am ahmad from overview" },
            //   }}
           
          >
           
          </Link> */}
        </span>
        {element.flag_edit_del_btn === "edit/del" && !element.close_date ? (
          <>
            <span>
              <Button
                style={{ margin: "3px" }}
                type="submit"
                size="sm"
                color="success"
                onClick={() => redirectToForm(row, true)}
                // disabled={rolesPermission}
              >
                Edit
              </Button>
            </span>

            <span>
              <Button
                style={{ margin: "3px" }}
                type="submit"
                size="sm"
                color="danger"
                onClick={() => setDelete(row)}
                // disabled={rolesPermission}
              >
                Delete
              </Button>
            </span>
          </>
        ) : null}
        {hasAttachment && (
          <span>
            <Button
              style={{ margin: "3px" }}
              size="sm"
              color="primary"
              title="View Attachment"
              onClick={() => handleViewAttachment(row)}
            >
              <GrAttachment />
            </Button>
          </span>
        )}
      </div>
    );
  }

  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 15,
    pageStartIndex: 1,
    paginationSize: 3,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to Last",
    paginationPosition: "top",
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "All",
        value: table.OverViewDataTable?.length,
      },
    ],
  };
  // console.log("table", table.OverViewDataTable);
  const handleViewAttachment = (row) => {
    setShowAttachmentModal(true);
    setSelectedRowDetails(row);
  };

  const closeAttachmentModal = () => {
    setShowAttachmentModal(false);
    setSelectedRowDetails(null);
  };

  const getPriorityLov = async () => {
    try {
      let prLov = await priorityLov();
      if (prLov && prLov[0]) {
        setPriorityList(prLov[0]);
      }
    } catch (error) {
      console.error("Error fetching priority LOV", error);
    }
  };

  const getCostCenterLov = () => {
    axios
      .post(
        `${baseurl}/lovs/getCostCenterDetLov`,
        { companyId: companyId, username: username, onlyDept: true },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        setCostCenterList(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      {loadingResponse === true ? (
        <ResponseLoader />
      ) : (
        <div className="container-fluid bg-white">
          <div className="row">
            <div className="col-md-6 h3 p-3">
              Inventory Purchase Demand Overview
            </div>
            <div className="float-right col-md-3 mt-3">
              <Link to={"/inventoryPDForm"}>
                <button
                  class="btn btn-outline-success rounded-pill mx-2"
                  title={"Create new Invoice"}
                  // disabled={this.state.rolesPermission}
                >
                  <i class="fa fa-plus pr-2" aria-hidden="true"></i>
                  New Inv.Purchase Demand
                </button>
              </Link>
            </div>
            <div className="float-right col-md-3 mt-3">
              <Link to={"/placeOrder"}>
                <button
                  class="btn btn-outline-success rounded-pill mx-2"
                  title={"Create new Invoice"}
                  // disabled={this.state.rolesPermission}
                >
                  <i class="fa fa-plus pr-2" aria-hidden="true"></i>
                  Place Order
                </button>
              </Link>
            </div>
          </div>
          <div className="row px-3 mt-3 mb-3">
            <div className="col-md-3">
              <Label>Priority</Label>
              <Select
                isClearable
                value={priority}
                options={priorityList}
                onChange={(e) => setPriority(e)}
                placeholder="-- Select Priority --"
              />
            </div>

            <div className="col-md-3">
              <Label>Cost Center</Label>
              <Select
                isClearable
                value={costCenter}
                options={costCenterList}
                onChange={(e) => setCostCenter(e)}
                placeholder="-- Select Cost Center --"
              />
            </div>

            <div className="col-md-2">
              <Label className="invisible">Action</Label>
              <br />
              <Button color="success" onClick={getData}>
                Find
              </Button>
            </div>
          </div>
          <div translate="no" className="">
            <BootstrapTable
              data={table.OverViewDataTable}
              striped
              pagination
              hover
              search
              tableHeaderClass="rpr_header"
              tableBodyClass="rpr_body"
              containerClass="rpr_container"
              options={options}
              version="4"
            >
              <TableHeaderColumn
                // dataFormat={indexN}
                dataAlign="center"
                dataSort={true}
                width="5%"
                dataField="dem_date"
                className="rpr_header"
              >
                Date
              </TableHeaderColumn>

              <TableHeaderColumn
                dataAlign="center"
                dataField="doc_no"
                isKey={true}
                width="5%"
                dataSort={true}
                className="rpr_header"

                // dataFormat={this.statusFormatorClient}
              >
                Doc_No.{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataAlign="center"
                dataField="from_desc"
                width="5%"
                dataSort={true}

                // dataFormat={this.statusFormatorClient}
              >
                Sub-Inventory{" "}
              </TableHeaderColumn>
              {/* <TableHeaderColumn
                dataAlign="center"
                dataField="to_desc"
                width="16%"
                dataSort={true}
              >
                To Sub-Inventory
              </TableHeaderColumn> */}
              <TableHeaderColumn
                dataAlign="center"
                dataField="remarks"
                width="16%"
                dataSort={true}
              >
                Remarks
              </TableHeaderColumn>
              <TableHeaderColumn
                dataAlign="center"
                dataField="pur_dem_id"
                width="10%"
                dataFormat={orderDetHandler}
              >
                Action
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
          <AttachmentViewModal
            show={showAttachmentModal}
            onHide={closeAttachmentModal}
            row={selectedRowDetails}
            moduleName={"Inventory Purchase Demand"}
            fieldMap={{
              docNo: "doc_no",
              date: "dem_date",
              type: "from_desc",
              attachment: "attachment_file",
            }}
          />
          <Modal
            show={closePoModelIsOpen}
            size="md"
            onHide={toggleClosePoModal}
            backdrop="static"
          >
            <Modal.Header
              closeButton
              onClick={() => toggleClosePoModal()}
              className=" Creative-Invoice-header-styling"
            >
              <h4> Close PO </h4>{" "}
            </Modal.Header>
            <Modal.Body className="">
              <div className="row">
                <ReactDatePicker
                  label="Close Date:"
                  className="col-md-6 col-lg-6 col-xl-6"
                  isSelected={closeDate}
                  isDisabled={true}
                />
                <div className="col-md-12 my-1">
                  <Label> Remarks:</Label>
                  <Input
                    rows="3"
                    type="textarea"
                    id="remarks"
                    name="remarks"
                    className="form-control"
                    value={remarks}
                    onChange={(e) => {
                      setremarks(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 float-right ">
                  <Button color="secondary" onClick={toggleClosePoModal}>
                    Cancel
                  </Button>
                  <Button color="primary" className="mx-2" onClick={closePo}>
                    Close
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
}
